export default __webpack_public_path__ + "static/media/rails.5cfa93ed.png";